import { useEffect } from 'react';
import { useAppSelector } from '../redux/ReduxProvider';
import { Outlet, useLocation } from 'react-router-dom';
import { useRouter } from '../hooks/useRouter';
import { DEFAULT_LANG } from '../constants/globals';
import { changeI18nLanguage } from '../helpers/i18n_helper';

//Keep track of whether the language have at any point been set either through
//the URL or through the a user language change
//This fixes a bug where some UI elements would not be translated
//When the user follows an email link
let languageHaveBeenSelected = null;

const LanguageParams = () => {
  const location = useLocation();
  const { selectedLanguage, languageISO } = useAppSelector((state) => state.languages);
  const { navigate } = useRouter();

  useEffect(() => {
    const langISOCode = (selectedLanguage && selectedLanguage.langISOCode) || languageISO || DEFAULT_LANG;
    const changeLanguage = async () => {
      await changeI18nLanguage(langISOCode);
      // Stamp the lang param onto the path the app is on *now*, not the one
      // captured when this effect was scheduled. Another redirect triggered by
      // the same state change (e.g. the survey guard sending a completed survey
      // to the thank-you page) has already run by this point; reusing the
      // captured path would overwrite that destination. `replace` keeps the
      // lang param out of the history stack.
      navigate(`${window.location.pathname}?lang=${langISOCode}`, { replace: true });
    };
    const url = new URL(window.location);
    const desiredLanguage = url.searchParams.get('lang');
    //Always ensure that the app sets the language at least once!
    if (!languageHaveBeenSelected || (desiredLanguage && desiredLanguage !== langISOCode)) {
      languageHaveBeenSelected = desiredLanguage;
      changeLanguage().catch((error) => console.log(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguage, languageISO, location.search]);

  return <Outlet />;
};

export default LanguageParams;
